import { restAxios } from './httpClient';
import { stripBlankParams } from '../helpers/queryParams';

const COMPLIANCE_VERDICTS_PATH = '/hardware/compliance-verdicts';

let getComplianceVerdictsController;

/*
 * The abort is load-bearing rather than a nicety. Paging or filtering quickly sends overlapping
 * reads, and one that lands out of order would leave a stale page on screen under the filter that
 * was chosen last - with live Grant and Revoke buttons on rows the operator did not ask to see.
 */
export const getComplianceVerdicts = (queryParams) => {
	getComplianceVerdictsController?.abort();

	getComplianceVerdictsController = new AbortController();
	const searchParams = new URLSearchParams(stripBlankParams(queryParams)).toString();

	return restAxios.get(`${COMPLIANCE_VERDICTS_PATH}?${searchParams}`, {
		signal: getComplianceVerdictsController.signal
	});
};

export const createComplianceVerdict = (payload) => {
	return restAxios.post(COMPLIANCE_VERDICTS_PATH, payload);
};

/*
 * Grant and revoke are POSTs to action paths, not PATCHes - `:grant` / `:revoke` is a literal suffix
 * on the resource id and must reach the server unencoded, so the id is interpolated bare. An
 * `encodeURIComponent` wrapped around the tail would send `%3Agrant` and 404.
 *
 * These are the only transitions a verdict supports: `new` -> `active` by granting, `active` ->
 * `revoked` by revoking. There is no update endpoint.
 */
export const grantComplianceVerdict = (id, payload) => {
	return restAxios.post(`${COMPLIANCE_VERDICTS_PATH}/${id}:grant`, payload);
};

export const revokeComplianceVerdict = (id, payload) => {
	return restAxios.post(`${COMPLIANCE_VERDICTS_PATH}/${id}:revoke`, payload);
};
